import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { IsOpen, Search } from '../../../components/Icon';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Pagination } from '../../../components/Pagination';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { changeInvoiceFilter, fetchVehicleInvoices } from '../../Invoices/actions';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { REQUEST_INVOICES, REQUEST_INVOICE_FILTER, REQUEST_VEHICLE_INVOICES } from '../../Invoices/constants';
import { selectInvoiceFilter, selectPaginator, selectVehicleInvoices } from '../../Invoices/selectors';
import { InvoicesCompanyTable } from '../../Invoices/components/InvoicesCompanyTable';
import { Loader } from '../../../components/Loader';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import cn from 'classnames';
import styles from './VehcleInvoicesCard.module.css';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';


const Container = styled.div`
display: flex;
justify-content: center;
  width: 100%;
  font-size: 14px;
  background-color:white;

  .cell:first-child {
    text-transform: capitalize;
  }
  .wide {
    width: 100%;
    max-width: 800px;
    /* overflow-x: ${props => (props.itemsLength ? 'auto' : '')}; */
  }

  .info-card {
  border: none;
  }

`;

const STATE = { searchString: '', isOpen: false, };

  


/* eslint-disable react/prefer-stateless-function */
class VehicleInvoicesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }


  componentDidMount() {
    this.props.setVehicleFilter();
    if (hasPermissions(this.props.permissions, DEP_FINANCE )) {
      this.setState({ isOpen: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filter?.vehicle_id !== prevProps?.filter?.vehicle_id) {
      this.props.setSearchString('');
    }
  }

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset));
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.searchString);
    }
  };

  doSearch() {
    this.props.setSearchString(this.state.searchString);
  }

  render() {
    const isInvoicePage = this.props.isInvoicePage;
    if (!this.props.filter?.vehicle_id) return <LoadingDetailsPageCard />;
    return (
      <Container itemsLength={this.props.invoices?.length} isInvoicePage={isInvoicePage}>
        <Card className={cn('vehicle-info-card info-card data wide', styles.card)} style={{ width: '100%' }}>
          <HBox vCenter>
            <h2 className="card-title mb-0 text-muted">{this.lbl('company.info.data.invoices')}</h2>
            <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>  
                <IsOpen />  
              </div>  
          </HBox>
          {this.state.isOpen && (
            <>
          <div className={styles.searchContainer}>
            <input
              className={`form-control fw-lighter ${styles.input}`}
              value={this.state.searchString}
              placeholder="Zoeken..."
              onChange={evt => this.setState({ searchString: evt.target.value })}
              onKeyPress={this.handleKeyPress}
            />
            <button
              className={`btn btn-outline-secondary ${styles.button}`}
              type="button"
              onClick={this.doSearch.bind(this)}
            >
              <Search />
            </button>
          </div>

          <div className={styles.containerTable}>
            <InvoicesCompanyTable
              vehicleDetails
              vehicleId={this.props.vehicle?.id}
              ActionsColComp={this.props.ActionsColComp}
            />
          </div>

          {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
            <div className="d-flex justify-content-center mt-2">
              <PaginationComponent size="pagination-sm" paginator={this.props.paginator} selectPage={this.selectPage} />
            </div>
          )}
          </>
        )}
        </Card>
      </Container>
    );
  }
}

VehicleInvoicesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectVehicleInvoices(),
    paginator: selectPaginator(),
    work: selectWorks([REQUEST_INVOICE_FILTER, REQUEST_VEHICLE_INVOICES]),
    filter: selectInvoiceFilter(),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    changeFilter: offset => {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, '', offset));
    },
    setVehicleFilter: () => {
      dispatch(changeInvoiceFilter('vehicle_id', ownProps.vehicle.id));
    },
    setSearchString(text) {
      dispatch(fetchVehicleInvoices(ownProps.vehicle?.id, text));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInvoicesCard = compose(withConnect, withRouter)(VehicleInvoicesCardComp);
